"use client";
import { getStrapiMedia } from "../lib/api-helpers";
import { useLayoutEffect } from "react";


interface Picture {
  data: {
    id: string;
    attributes: {
      url: string;
      name: string;
      alternativeText: string;
    };
  };
}

interface HeroProps {
  data: {
    id: string;
    arcDirection: string;
    file: Picture;
  };
}

export default function HeroImageCase({ data }: HeroProps) {
  const imgUrl = getStrapiMedia(data?.file?.data?.attributes?.url);


  function removeStyle() {  
    const htmlElement = document.documentElement;

    htmlElement.style.scrollSnapType = "";
    htmlElement.style.scrollPaddingTop = "";
    htmlElement.style.scrollBehavior = "";
    htmlElement.style.scrollSnapStop = "";
  }


  useLayoutEffect(() => {
    return () => {
      window.scrollTo(0, 0);
      removeStyle();
    };
  }, []);



  return (
    <div className='flex flex-col items-center justify-center text-gray-600 body-font mt-[60px] mb-[40px]'>
      <div
        className="flex items-center justify-center flex-col overflow-hidden">
        <div>
          <img
            src={imgUrl ?? ""}
            className="w-full relative z-30 object-contain object-center md:h-auto lg:h-[500px] xl:h-[480px]"
            alt={data.file?.data?.attributes?.name ?? "Hero Image"}
          />
        </div>
      </div>
    </div>
  );
}
